import * as THREE from 'three';
import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';

/**
 * Carga un HDRI equirectangular y lo convierte en un environment map prefiltrado
 * (PMREM) para iluminación basada en imagen (IBL). Lo asigna como `environment`
 * y como `background` (cielo) de la escena.
 *
 * @returns el environment map generado (para poder hacer dispose más tarde).
 */
export async function loadEnvironment(
  renderer: THREE.WebGLRenderer,
  scene: THREE.Scene,
  url: string,
): Promise<THREE.Texture> {
  const pmrem = new THREE.PMREMGenerator(renderer);
  pmrem.compileEquirectangularShader();

  const hdrTexture = await new RGBELoader().loadAsync(url);
  hdrTexture.mapping = THREE.EquirectangularReflectionMapping;

  const envMap = pmrem.fromEquirectangular(hdrTexture).texture;
  scene.environment = envMap;
  // El fondo es el cielo neutro (world.buildSkyBackground); el HDRI solo ilumina/refleja.

  hdrTexture.dispose();
  pmrem.dispose();

  return envMap;
}
